import React from 'react';
import ReactECharts from 'echarts-for-react';

const PaymentSummaryAnalytics = ({ payments }) => {
  const statusData = [
    { value: payments.filter(p => p.status === 'Paid').length, name: 'Paid' },
    { value: payments.filter(p => p.status === 'Overdue').length, name: 'Overdue' },
    { value: payments.filter(p => p.status === 'Pending').length, name: 'Pending' }
  ];

  const option = {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { bottom: '0', left: 'center', textStyle: { fontSize: 10, fontWeight: 'bold' }, icon: 'circle' },
    series: [
      {
        name: 'Payment Status',
        type: 'pie',
        radius: ['45%', '75%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
        label: { show: false },
        emphasis: { label: { show: true, fontSize: '12', fontWeight: 'bold' } },
        data: statusData,
        color: ['#10B981', '#EF4444', '#4F46E5']
      }
    ]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm h-full">
      <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-4">Collection Breakdown</h3>
      <div className="h-[250px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default PaymentSummaryAnalytics;